import {
  elisaMode,
  hisenseMode,
  Mode,
  philipsMode,
  vestelMode,
  panasonicMode,
  ps5Mode,
  sonyMode,
  teliaMode,
  tizenMode,
  webOsMode,
  tivoMode,
} from '../../common/types';

export const isValidSearchKey = (key: string): boolean => {
  return /^[a-z0-9 äöå]$/i.test(key);
};

export const isValidProfileNameKey = (key: string): boolean => {
  return /^[a-zA-Z0-9ÄäÖöÅå _-]$/i.test(key);
};

export const isValidLoginKey = (key: string): boolean => {
  return /^[a-zA-Z0-9ÄäÖöÅå~`!@#\$¢£€%&\*\(\)_\-\+={\[\}\]\|\\:;"'<,>\.\?\/ \u00C0-\u017F]$/.test(
    key
  );
};

export const Keys = {
  VK_LEFT: 37,
  VK_UP: 38,
  VK_RIGHT: 39,
  VK_DOWN: 40,
  VK_ENTER: 13,
  VK_SPACE: 32,
  VK_BACK: 8,
  VK_BACKSPACE: 8,
  VK_0: 48,
  VK_1: 49,
  VK_2: 50,
  VK_3: 51,
  VK_4: 52,
  VK_5: 53,
  VK_6: 54,
  VK_7: 55,
  VK_8: 56,
  VK_9: 57,
  VK_FAST_FWD: 190,
  VK_REWIND: 188,
  VK_PLAY: 80,
  VK_PAUSE: 76,
  VK_PLAY_PAUSE: 75,
  VK_STOP: 83,
  VK_PLUS: 187,
  VK_MINUS: 189,
  VK_ESC: 27,
  VK_TAB: 9,
  VK_SHIFT: 16,
  VK_RED: 112,
  VK_HOME: 36,
};

const hasHbbTVKeys = (): boolean =>
  typeof window.KeyEvent !== 'undefined' &&
  typeof window.KeyEvent.VK_LEFT !== 'undefined';

export const bindKeysIfNoExist = (mode: Mode) => {
  if (hasHbbTVKeys()) {
    Keys.VK_LEFT = window.KeyEvent.VK_LEFT;
    Keys.VK_UP = window.KeyEvent.VK_UP;
    Keys.VK_RIGHT = window.KeyEvent.VK_RIGHT;
    Keys.VK_DOWN = window.KeyEvent.VK_DOWN;
    Keys.VK_ENTER = window.KeyEvent.VK_ENTER;
    Keys.VK_BACK = window.KeyEvent.VK_BACK;
    Keys.VK_FAST_FWD = window.KeyEvent.VK_FAST_FWD;
    Keys.VK_REWIND = window.KeyEvent.VK_REWIND;
    Keys.VK_PLAY = window.KeyEvent.VK_PLAY;
    Keys.VK_PAUSE = window.KeyEvent.VK_PAUSE;
    Keys.VK_STOP = window.KeyEvent.VK_STOP;
    Keys.VK_PLAY_PAUSE = window.KeyEvent.VK_PLAY_PAUSE;
    Keys.VK_RED = window.KeyEvent.VK_RED;
  }

  switch (mode) {
    case webOsMode:
    case hisenseMode:
    case philipsMode:
    case panasonicMode:
    case vestelMode:
    case sonyMode:
      Keys.VK_BACK = 461;
      Keys.VK_FAST_FWD = 417;
      Keys.VK_REWIND = 412;
      Keys.VK_PLAY = 415;
      Keys.VK_PAUSE = 19;
      Keys.VK_STOP = 413;
      Keys.VK_PLAY_PAUSE = 0;
      break;
    case tivoMode:
      Keys.VK_BACK = 461;
      Keys.VK_FAST_FWD = 417;
      Keys.VK_REWIND = 412;
      Keys.VK_STOP = 413;
      Keys.VK_PLAY = 415;
      Keys.VK_PAUSE = 19;
      Keys.VK_PLAY_PAUSE = 463;
      break;
    case tizenMode:
      Keys.VK_BACKSPACE = 8;
      Keys.VK_BACK = 10009;
      Keys.VK_FAST_FWD = 417;
      Keys.VK_REWIND = 412;
      Keys.VK_PLAY = 415;
      Keys.VK_PAUSE = 19;
      Keys.VK_STOP = 413;
      Keys.VK_PLAY_PAUSE = 10252;
      break;
    case teliaMode:
      Keys.VK_BACK = 44;
      Keys.VK_BACKSPACE = 8;
      Keys.VK_FAST_FWD = 417;
      Keys.VK_REWIND = 412;
      Keys.VK_PLAY = 0;
      Keys.VK_PAUSE = 0;
      Keys.VK_PLAY_PAUSE = 415;
      Keys.VK_STOP = 413;
      break;
    case elisaMode:
      Keys.VK_BACK = 461;
      Keys.VK_BACKSPACE = 8;
      Keys.VK_FAST_FWD = 417;
      Keys.VK_REWIND = 412;
      Keys.VK_PLAY = 0;
      Keys.VK_PAUSE = 0;
      Keys.VK_PLAY_PAUSE = 402;
      Keys.VK_STOP = 413;
      break;
    case ps5Mode:
      Keys.VK_BACK = 27;
      Keys.VK_BACKSPACE = 8;
      Keys.VK_FAST_FWD = 134;
      Keys.VK_REWIND = 133;
      Keys.VK_PLAY = 179;
      Keys.VK_PAUSE = 135;
      Keys.VK_PLAY_PAUSE = 217;
      Keys.VK_STOP = 178;
      break;
  }
};
